import { render, staticRenderFns } from "./OrginationPositionView.vue?vue&type=template&id=0b36fa3e&scoped=true"
import script from "./OrginationPositionView.vue?vue&type=script&lang=js"
export * from "./OrginationPositionView.vue?vue&type=script&lang=js"
import style0 from "./OrginationPositionView.vue?vue&type=style&index=0&id=0b36fa3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b36fa3e",
  null
  
)

export default component.exports